import { locale, t } from './i18n';

const dateTime = new Intl.DateTimeFormat(locale, {
  dateStyle: 'medium',
  timeStyle: 'short',
  timeZone: 'Europe/Belgrade',
});
const dateOnly = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone: 'Europe/Belgrade' });

export const formatDateTime = (v?: string | Date | null) => (v ? dateTime.format(new Date(v)) : '—');
export const formatDate = (v?: string | Date | null) => (v ? dateOnly.format(new Date(v)) : '—');

export function timeAgo(v: string | Date) {
  const s = Math.round((Date.now() - new Date(v).getTime()) / 1000);
  if (s < 60) return t('just now');
  if (s < 3600) return t('{n} min ago', { n: Math.floor(s / 60) });
  if (s < 86400) return t('{n} h ago', { n: Math.floor(s / 3600) });
  return formatDate(v);
}
